export default {"src":"/_next/static/media/geography.e6e35daa.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};